import { jsonParse } from "../utils";
import CryptoJS from "crypto-js";
// const CryptoJS = require("crypto-js");

export const CryptoJSAesJson = {
  stringify: function (cipherParams) {
    var j = { ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64) };
    if (cipherParams.iv) j.iv = cipherParams.iv.toString();
    if (cipherParams.salt) j.s = cipherParams.salt.toString();
    return JSON.stringify(j);
  },
  parse: function (jsonStr) {
    const j = jsonParse(jsonStr);
    const cipherParams = CryptoJS.lib.CipherParams.create({
      ciphertext: CryptoJS.enc.Base64.parse(j.ct),
    });
    if (j.iv) cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv);
    if (j.s) cipherParams.salt = CryptoJS.enc.Hex.parse(j.s);
    return cipherParams;
  },
};
export const CryptoJSAesString = {
  stringify: function (cipherParams) {
    var s = `${cipherParams.ciphertext.toString(
      CryptoJS.enc.Base64
    )}|||||${cipherParams.iv.toString()}|||||${cipherParams.salt.toString()}`;
    return s;
  },
  parse: function (jsonStr) {
    const j = JSON.parse(jsonStr);
    const cipherParams = CryptoJS.lib.CipherParams.create({
      ciphertext: CryptoJS.enc.Base64.parse(j.ct),
    });
    if (j.iv) cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv);
    if (j.s) cipherParams.salt = CryptoJS.enc.Hex.parse(j.s);
    return cipherParams;
  },
};
export default class Enc {
  static md5(input) {
    return CryptoJS.MD5(input).toString();
  }

  static base64Enc({ input }) {
    const encodedWord = CryptoJS.enc.Utf8.parse(input); // encodedWord Array object
    return CryptoJS.enc.Base64.stringify(encodedWord);
  }

  static base64EncSafe({ input }) {
    return Enc.normalize(Enc.base64Enc({ input }));
  }

  static base64DecSafe({ input }) {
    const str = Enc.unNormalize(input);
    return Enc.base64Dec({ input: str });
  }

  static base64Dec({ input }) {
    const parsedWordArray = CryptoJS.enc.Base64.parse(input);
    return parsedWordArray.toString(CryptoJS.enc.Utf8);
  }

  static SHA256({ input }) {
    return CryptoJS.SHA256(input).toString();
  }

  static encAESForARC({ query }) {
    const stringfy = JSON.stringify(query);
    const hash = Enc.md5({ input: stringfy });
    const key = Enc.md5("123456789_" + hash);
    const enc1 = CryptoJS.AES.encrypt(stringfy, key, {
      format: CryptoJSAesString,
    });
    return {
      enc: Enc.normalize(enc1.toString()),
      sign: hash,
    };
  }

  static decAESForARC({ enc }) {
    const [iv, salt, hash, response] = enc.split("|||||");
    return CryptoJS.AES.decrypt(
      JSON.stringify({ iv: iv, s: salt, ct: response }),
      Enc.md5("123456789_" + hash),
      {
        format: CryptoJSAesJson,
      }
    ).toString(CryptoJS.enc.Utf8);
  }

  static normalize(str) {
    str = str.replace(/\//g, "_");
    str = str.replace(/=/g, "-");
    str = str.split("+").join("~");
    return str;
  }
  static unNormalize(str) {
    str = str.replace(/_/g, "/");
    str = str.replace(/-/g, "=");
    str = str.split("~").join("+");
    return str;
  }
}
